import { Flex, Text } from '@bitrise/bitkit';
import React, { useContext, FunctionComponent } from 'react';
import { AuthContextFirebase } from '../Authenticate/AuthenticateFirebase';

const AppInfo: FunctionComponent = () => {
  const {
    data: { appTitle, appId, plan },
  } = useContext(AuthContextFirebase);

  return (
    <Flex>
      <Flex direction="horizontal" gap="x4" margin="x5">
        <Flex grow initial="none">
          <Text weight="bold">App Name</Text>
          <Text textColor="gray-7">{appTitle}</Text>
        </Flex>

        <Flex grow initial="none">
          <Text weight="bold">App ID</Text>
          <Text textColor="gray-7">{appId}</Text>
        </Flex>

        <Flex grow initial="none">
          <Text weight="bold">Plan</Text>
          <Text textColor="gray-7">{plan}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AppInfo;
